import { memo, type ReactNode } from "react";

interface StepInfoRowProps {
  icon: ReactNode;
  label: string;
  value: string | ReactNode;
  mono?: boolean;
}

function StepInfoRowComponent({ icon, label, value, mono = false }: StepInfoRowProps) {
  return (
    <div className="flex items-start gap-2 text-xs">
      <span className="mt-0.5 shrink-0 text-gray-400">{icon}</span>
      <div className="min-w-0 flex-1">
        <span className="text-gray-500 dark:text-gray-400">{label}: </span>
        <span className={`text-gray-700 dark:text-gray-300 ${mono ? "font-mono text-[11px]" : ""}`}>
          {value}
        </span>
      </div>
    </div>
  );
}

export const StepInfoRow = memo(StepInfoRowComponent);
